<div class="col-md-12" *ngIf="isLoading">
  <app-busy [message]="message"></app-busy>
</div>
<div class="row">
  <div style="margin-top:10px; margin-bottom:-10px;">
    <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b>&nbsp;Approve Carrier Accounts</b></h5>
  </div>
</div>
<hr>
<fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;">
  <div class="row" style="margin:15px auto!important;padding-left:100px;">
    <div class="col-3" style="margin:0px!important;padding:0px!important;">
      <input type="text" style="width:280px!important;height:35px"
             class="form-control form-control-lg pull-right"
             [(ngModel)]="carrierName"
             placeholder="Filter by carrier name..."
             title="Enter the Carrier name to filter by..."
             (keypress)="checkKey($event)">
    </div>
    <div class="col-3">
      <input type="text" style="width:210px!important;height:35px"
             class="form-control form-control-lg"
             [(ngModel)]="carrierNumber"
             placeholder="Filter by account number..."
             title="Enter the Account number to filter by..."
             (keypress)="checkKey($event)">
    </div>
      <div class="col-4 resizer" style="width:350px; padding:0px" title="Select one or more statuses to filer by...">
      <ng-multiselect-dropdown [placeholder]="'Filter by one or more statuses...'"
                               [data]="statuses"
                               [(ngModel)]="selectedItems"
                               [settings]="dropdownSettings"
                               (onSelect)="onItemSelect($event)"
                               (onDeSelect)="onDeSelect($event)"
                               (onSelectAll)="onSelectAll($event)">
      </ng-multiselect-dropdown>
    </div>
    <div class="col-2 btn-show" style="width:80px !important; margin:0px!important;padding-top:0px!important;">
      <span (click)="onReset()" title="Reset filters..." class="btn btn-success btn-sm pull-right"><i class="fa fa-undo" aria-hidden="true"></i></span>
      <span title="Apply filters..." (click)="onSearch()" class="btn btn-primary btn-sm pull-right" style="margin-right: 6px !important;"><i class="fa fa-filter" aria-hidden="true"></i></span>
    </div>
  </div>
</fieldset>
<br>
<!-- <button title="Refresh Permit Applications" style="margin-top:-5px; color:black; background:white" class="btn btn-secondary btn-sm pull-left" (click)="loadAccounts()"><i class="fa fa-refresh" aria-hidden="true"></i></button> -->
<fieldset  style="margin:0px;padding:0px;"><span><h5>Carrier Accounts</h5></span>
  <!-- <legend class="scheduler-border tsk-display blackcontrol">Carrier Accounts</legend> -->
  <div class="row" style="margin:4px auto!important;padding:0px">
    <div class="col-12" style="margin:0px!important;padding:0px!important;">
      <table class="table table-sm table-striped" style="width:100%;">
        <thead class="thead-inverse">
          <tr class="hd-clpse">
            <th class="bfr-end-col">
              Lock status
            </th>
            <th style="width:10%;">
              Account No
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i>
            </th>
            <th style="width:20%;">
              Account Name
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }" (click)="onSort(2)"></i>
            </th>
            <th>
              Lead User
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagLU == 2),'fa-sort-desc sort-d': (flags.flagLU == 3), 'fa-sort':(flags.flagLU == 1) }" (click)="onSort(3)"></i>
            </th>
            <th style="width:20%;">
              Carrier Type
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagCT == 2),'fa-sort-desc sort-d': (flags.flagCT == 3), 'fa-sort':(flags.flagCT == 1) }" (click)="onSort(4)"></i>
            </th>
            <th style="width:10%;">
              Submitted On
              <i style="vertical-align:middle; float:right;" class="fa " [ngClass]="{'fa-sort-asc sort-a': (flags.flagDS == 2),'fa-sort-desc sort-d': (flags.flagDS == 3), 'fa-sort':(flags.flagDS == 1) }" (click)="onSort(6)"></i>
            </th>
            <th style="width:15%;">
              Status
              <i style="vertical-align:middle; float:right;" class="fa " [ngClass]="{'fa-sort-asc sort-a': (flags.flagST == 2),'fa-sort-desc sort-d': (flags.flagST == 3), 'fa-sort':(flags.flagST == 1) }" (click)="onSort(5)"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="tbl-row" *ngFor="let item of accounts | orderBy: criteria : direction | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}">
            <!-- <td class="bfr-end-col">{{item.AccountNumber}}</td> -->
            <td class="bfr-end-col">
              <span *ngIf="item.isLocked==true" title="Locked by '{{item.isLockedBy}}', Click to unlock" style="margin: 0%" class="btn btn-md pull-center" (click)="unLockApplication(item)" >
                <i class="fa fa-lock" aria-hidden="true" style="color: red;"></i>                
              </span>
              <span *ngIf="item.isLocked==false || item.isLocked==undefined " title="Unlocked" style="margin: 0%" class="btn btn-md pull-center" >
                <i class="fa fa-unlock" aria-hidden="true" style="color: green;"></i>                
              </span>
            </td>
            <td class="bfr-end-col"><a [routerLink]="['/carrier/account/edit/' + item.Id + '/' + 1]" style="color:#00008b; text-decoration: underline;"><span title ="View account details">{{item.AccountNumber}}</span></a></td>
            <td class="longtext bfr-end-col" title="{{item.Name}}">{{item.Name}}</td>
            <td class="bfr-end-col">{{item.LeadUser}}</td>
            <td class="bfr-end-col">{{item.CarrierType}}</td>
            <td class="bfr-end-col">{{item.DateSubmitted?.toLocaleString() | date:'dd/MM/yyyy'}}</td>
            <td class="bfr-end-col">{{item.Status}}</td>
            <td class="btn-show end-col" style="width:10%!important;">
              <span title="View Carrier Account" class="btn btn-primary btn-sm pull-center" (click)="onViewAccount(item.Id)"><i class="fa fa-list" aria-hidden="true"></i></span>
              <span *ngIf="item.isLocked != true" title="Process Carrier Account" [ngClass]="{'disabled':item.status_id==1}" style="margin: 0%" class="btn btn-success btn-sm pull-center" (click)="onProcess(2,item)">
                <img src="/assets/permit-viewer2.png" class="permit-view" />
              </span>

              <span *ngIf="item.isLocked == true && item.isLockedBy == currentUserName" title="Process Carrier Account" [ngClass]="{'disabled':item.status_id==1}" style="margin: 0%" class="btn btn-success btn-sm pull-center" (click)="onProcess(2,item)">
                <img src="/assets/permit-viewer2.png" class="permit-view" />
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">

                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No carrier accounts found.</span>
            </td>
          </tr>
        </tfoot>
        <br>
      </table>
      <p class="use-mouse" style="color:#1D3F94">Use your mouse to hover over a code to see the description</p>
    </div>
  </div>
</fieldset>

